<template>
  <component :is="slot" :index="index" />
</template>

<script>
const LeaderboardAd = () => import('@/components/Ads/Advertserve/LeaderboardAd.vue');
const RecordAd = () => import('@/components/Ads/Advertserve/RecordAd.vue');
const ResultsAd = () => import('@/components/Ads/Advertserve/ResultsAd.vue');
const LandingAd = () => import('@/components/Ads/Advertserve/LandingAd.vue');
const SearchBannerAd = () => import('@/components/Ads/Advertserve/SearchBannerAd.vue');

export default {
  props: {
    adSlot: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  computed: {
    slot() {
      switch (this.adSlot) {
        case 'LeaderboardAd':
          return LeaderboardAd;
        case 'RecordAd':
          return RecordAd;
        case 'ResultsAd':
          return ResultsAd;
        case 'LandingAd':
          return LandingAd;
        case 'SearchBannerAd':
          return SearchBannerAd;
        default:
          return '';
      }
    },
  },
};
</script>
